import { AxiosError } from 'axios';
import { ginzaxiaomaApiRequest } from '.';
import { UserInfo, UserLoginRequestDto } from 'types/user';

export const getUserInfo = () => {
  return ginzaxiaomaApiRequest
    .get<UserInfo>('/admin/sso/current')
    .catch((err: AxiosError) => {
      if (err.response?.status === 401) {
        // fix: 登陆页无限刷新
        if (window.location.pathname === '/login') return;
        window.location.href = '/login';
      }
    });
};

export function userLogin(data: UserLoginRequestDto) {
  return ginzaxiaomaApiRequest.post<{ token: string }>(
    '/admin/sso/login',
    data,
  );
}
